import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';

export const listRenameCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.LIST_RENAME);
    if (!hint) return false;

    return !!getHintCanShow(state, EHintKey.LIST_RENAME);
};
